import SeoHead from "@/components/SeoHead";
import { SITE } from "@/data/siteData";

export default function MentionsLegales() {
  return (
    <>
      <SeoHead title={`Mentions légales - ${SITE.name}`} canonicalPath="/mentions-legales" noIndex />
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-black text-[#00367e] mb-8">Mentions légales</h1>
          <div className="prose max-w-none text-slate-700 leading-relaxed space-y-5">
            <h2 className="text-2xl font-bold text-[#00367e]">Éditeur du site</h2>
            <p>{SITE.legalName}<br/>{SITE.address.street}, {SITE.address.postalCode} {SITE.address.city}<br/>Téléphone : {SITE.phoneDisplay}<br/>Email : {SITE.email}</p>
            <h2 className="text-2xl font-bold text-[#00367e]">Hébergement</h2>
            <p>Site hébergé sur une infrastructure professionnelle sécurisée.</p>
            <h2 className="text-2xl font-bold text-[#00367e]">Propriété intellectuelle</h2>
            <p>L'ensemble du contenu du site (textes, images, logos) est protégé par le droit d'auteur. Toute reproduction sans autorisation est interdite.</p>
            <h2 className="text-2xl font-bold text-[#00367e]">Données personnelles</h2>
            <p>Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ce droit, contactez-nous à {SITE.email}.</p>
          </div>
        </div>
      </section>
    </>
  );
}
